var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.address)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.props.address.street))]),_c('div',[_vm._v("\n    "+_vm._s(_vm.props.address.zipcode)+" - "+_vm._s(_vm.props.address.city)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }